import React, { useState } from 'react'
import { CircularProgress, FormControl, LinearProgress, TextField, Typography } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import api from '../services/api'
import { ConnectingAirportsOutlined } from '@mui/icons-material'
import { useFormError } from './Datatable/FormErrorProvider'
import CustomTextField from './CustomTextField'


export default function LineSelect({handlerSrv,handlerLine,callbackAfterRequest, valueLine, valueSrv, olt, size="medium" , ...props }) {
    const [lines, setLines] = useState([])
    const [srvs, setSrvs] = useState([])
    const error =  useFormError()
    const [loading, setLoading] = React.useState(false)
    React.useLayoutEffect(() => {
        if (!olt) return
        setLoading(true)
        api.get(`provisioning/olt/onu/lines_srvs/${olt}`).then(res => {
            setLines(res.data.lines)
            setSrvs(res.data.srvs)
          
        }).finally(()=>{
          setLoading(false)
          callbackAfterRequest()
        })
      }, [olt])
 
  return (
    !loading ? 
      <>
      <FormControl 
      {...props}
      >
      <Autocomplete
      
      id="srv-outlined"
      options={srvs}
      onChange={(event, newValue) => {
  
        handlerSrv(newValue?.id)
      }}
      key={(option) => option.id}
      loadingText={"Buscando..."}
      noOptionsText={"Sem opções"}
       loading={loading}
      isOptionEqualToValue={(option, value) => value?.id  && option.id == value.id }
      getOptionLabel={(option) => option.id + ' - ' +option.name   }
      value={valueSrv ? srvs.find(e => e.id == valueSrv) : null}
      filterSelectedOptions
      renderInput={(params) => (
        <CustomTextField
        error={error.verify('srv')}
        helperText={error.msgError('srv')}
        {...params}
        size={size}
        label="Service Profile"
        />
      )}
      />
      </FormControl>
      <FormControl 
      {...props}
      >
      <Autocomplete
      
      id="lines-outlined"
      options={lines}
      onChange={(event, newValue) => {
  
        handlerLine(newValue?.id)
      }}
      key={(option) => option.id}
      
      isOptionEqualToValue={(option, value) => value?.id  && option.id == value.id }
      getOptionLabel={(option) => option.id + ' - ' +option.name   }
      value={valueLine ? lines.find(e => e.id == valueLine) : null}
      filterSelectedOptions
      loadingText={"Buscando..."}
      noOptionsText={"Sem opções"}
       loading={loading}
      renderInput={(params) => (
        <CustomTextField
        error={error.verify('line')}
        helperText={error.msgError('line')}
        {...params}
        size={size}
        label="Line Profile"
        />
      )}
      />
      </FormControl>
      </>
      
      : 
      <CustomTextField
      {...props}
      disabled={true}
      size={size}
      label="Aguardando OLT..."
      />
   
    )
  }